import React from "react";
import { Modal } from "react-bootstrap";

import GemDetailView from "./GemDetailView";

export default function GemDetailModal({ show, onHide, uid, category_uid, language_code = "en" }) {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>
          Gem detail {uid ? <span className="text-muted small">({uid})</span> : null}
          {language_code ? (
            <span className="text-muted small ms-2">· {language_code}</span>
          ) : null}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {uid ? (
          <GemDetailView
            uid={uid}
            category_uid={category_uid}
            language_code={language_code}
          />
        ) : null}
      </Modal.Body>
    </Modal>
  );
}

